import { PessoaUnidade } from "./pessoa-unidade";

export class Veiculo {
    id: number;
    modelo: string;
    cor: string;
    marca: string;
    placa: string;
    nomePessoa: string;
    tipoVeiculo: string;
    pessoaUnidade: PessoaUnidade;
    ativo: Boolean;
    foto: any;
    proprietarioId:number;
    proprietario:any;
    integrado:boolean;
}